<template>
  <div>
    <Panel
      :module="panel.module"
      :title="panel.title"
      :showFilter="panel.showFilter"
      :showSearch="panel.showSearch"
      :showButtons="panel.showButtons"
    >
      <div slot="content-buttons">
        <slot name="content-buttons"></slot>
      </div>
      <div slot="content-main">
        <slot name="content-main"></slot>
      </div>
    </Panel>
    <SaveCancel :formName="panel.formName">
      <slot name="save-buttons"></slot>
    </SaveCancel>
  </div>
</template>

<script>
import Panel from "@nixweb/nixloc-ui/src/component/layout/Panel";
import SaveCancel from "@nixweb/nixloc-ui/src/component/shared/SaveCancel";

export default {
  name: "ViewTemplateCrud",
  components: { Panel, SaveCancel },
  props: {
    panel: Object,
  },
};
</script>
